export const getCurrentDate = () => {
  const now = new Date();
  const offset = now.getTimezoneOffset();
  const localDate = new Date(now.getTime() - offset * 60 * 1000);
  return localDate.toISOString().slice(0, 16);
};

export const formatNoteDate = (dateString: string) => {
  const date = new Date(dateString);
  date.setSeconds(0);
  date.setMilliseconds(0);
  return date.toISOString();
};

/**
 * A note without an author is written by the CRM itself: «Битрикс24» for a
 * call or comment copied from Bitrix24 (origin 'b24'), else «1С» (a payment).
 */
export const systemAuthorKey = (note?: { origin?: string | null } | null) =>
  note?.origin === "b24"
    ? "resources.notes.bitrix_added"
    : "resources.notes.system_added";
